var React = require('react');

function CircleIconTextInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"strokeWidth":"2","fillRule":"evenodd"},[React.createElement("rect",{"className":"circle","width":"65","height":"65","rx":"32.5","transform":"translate(1 1)","key":0}),React.createElement("g",{"strokeLinecap":"square","key":1},React.createElement("path",{"className":"icon","d":"M21.929 25.5h24.142M21.929 41.5h24.142M21.944 33.5h15.112"}))]));
}

CircleIconTextInline.defaultProps = {"viewBox":"0 0 68 68"};

module.exports = CircleIconTextInline;

CircleIconTextInline.default = CircleIconTextInline;
